import MD5 from 'blueimp-md5'

/**
 * @author chuwei
 * @date 2019/5/16 13:37
 * @description:登录密码加密
 **/
function PwdMd5(str) {
  let res = MD5(str.toString())
  let temp = ''
  for (let i = 0; i < res.length; i++) {
    temp += res[i]
    if (i % 2 !== 0) {
      temp += '-'
    }
  }
  return temp.substr(0, temp.length - 1).toLocaleUpperCase()
}

/**
 * @author chuwei
 * @date 2019/5/16 13:53
 * @description:校验手机号
 **/
function checkPhone(value) {
  if (value) {
    let reg = /^1\d{10}$/
    return reg.test(value.toString().trim())
  }
}

/**
 * @author chuwei
 * @date 2019/5/16 13:54
 * @description:校验身份证号
 **/
function checkIdCard(value) {
  if (value) {
    let reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
    return reg.test(value.toString().trim());
  }
}

/**
 * @author chuwei
 * @date 2019/6/26 14:41
 * @description:判断数据的类型
 **/
function checkType(target) {
  return Object.prototype.toString.call(target).slice(8, -1)
}

/**
 * @author chuwei
 * @date 2019/6/26 14:43
 * @description:深拷贝数组或者是对象,深度克隆（复制）
 **/
function copy(target) {
  let res
  let targetType = checkType(target)
  if (targetType === 'Object') {
    res = {}
  } else if (targetType === 'Array') {
    res = []
  } else {
    return target
  }
  for (let i in target) {
    let value = target[i]
    if (checkType(value) === 'Object' || checkType(value) === 'Array') {
      res[i] = copy(value)
    } else {
      res[i] = value
    }
  }
  return res
}

/**
 * @author chuwei
 * @date 2019/6/28 11:09
 * @description:判断是否是微信浏览器
 **/
function isWeixin() {
  let ua = window.navigator.userAgent.toLowerCase();
  return /MicroMessenger/i.test(ua)
}

/**
 * @author chuwei
 * @date 2019/7/16 15:54
 * @description:通过微信内置Api判断是否是微信浏览器
 **/
function isWxClient() {
  return typeof WeixinJSBridge !== "undefined"
}

/**
 * @author chuwei
 * @date 2019/7/17 15:25
 * @description:设置sessionStorage
 **/
function setSessionStorage(key, value) {
  if (window.sessionStorage) {
    sessionStorage.setItem(key, JSON.stringify(value))
  } else {
    alert('您的浏览器不支持sessionStorage存储')
  }
}

/**
 * @author chuwei
 * @date 2019/7/17 15:26
 * @description:获取sessionStorage
 **/
function getSessionStorage(key) {
  if (window.sessionStorage) {
    return JSON.parse(sessionStorage.getItem(key))
  } else {
    alert('您的浏览器不支持sessionStorage存储')
  }
}

/**
 * @author chuwei
 * @date 2019/7/17 15:27
 * @description:移除sessionStorage
 **/
function removeSessionStorage(key) {
  if (window.sessionStorage) {
    sessionStorage.removeItem(key)
  } else {
    alert('您的浏览器不支持sessionStorage存储')
  }
}

/**
 * @author chuwei
 * @date 2019/7/17 15:28
 * @description:设置localStorage
 **/
function setLocalStorage(key, value) {
  if (window.localStorage) {
    localStorage.setItem(key, JSON.stringify(value))
  } else {
    alert('您的浏览器不支持localStorage存储')
  }
}

/**
 * @author chuwei
 * @date 2019/7/17 15:28
 * @description:获取localStorage
 **/
function getLocalStorage(key) {
  if (window.localStorage) {
    return JSON.parse(localStorage.getItem(key))
  } else {
    alert('您的浏览器不支持localStorage存储')
  }
}

/**
 * @author chuwei
 * @date 2019/7/17 15:29
 * @description:移除localStorage
 **/
function removeLocalStorage(key) {
  if (window.localStorage) {
    localStorage.removeItem(key)
  } else {
    alert('您的浏览器不支持localStorage存储')
  }
}

/**
 * @author chuwei
 * @date 2019/7/24 14:32
 * @description:格式化url后面的参数
 **/
function formatQuery() {
  let oGetVars = {};
  if (window.location.search.length > 1) {
    for (let aItKey, nKeyId = 0, aCouples = window.location.search.substr(1).split("&"); nKeyId < aCouples.length; nKeyId++) {
      aItKey = aCouples[nKeyId].split("=");
      oGetVars[decodeURIComponent(aItKey[0])] = aItKey.length > 1 ? decodeURIComponent(aItKey[1]) : "";
    }
  }
  return oGetVars
}

/**
 * @author chuwei
 * @date 2019/7/24 14:33
 * @description:获取url参数
 **/
function getQuery(key) {
  return decodeURI(window.location.search.replace(
    new RegExp("^(?:.*[&\\?]" + encodeURI(key).replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));
}

/**
 * @author chuwei
 * @date 2019/7/25 10:17
 * @description:获取n到m的随机数
 **/
function random(n, m) {
  n = +n || 0
  m = +m || 0
  return Math.random() * (m - n) + n;
}

/**
* @author chuwei
* @date 2020/12/17 14:07
* @description:解析crm的返回值
**/
function parseJsonOrNot(str = '') {
  try {
    if (typeof JSON.parse(str) == 'object') {
      return JSON.parse(str)
    } else {
      return str
    }
  } catch (e) {
    return str
  }
}

/**
 * @author chuwei
 * @date 2020/11/26 15:03
 * @description:base64编码
 **/
function btoa(string) {
  const b64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
  string = String(string)
  var bitmap, a, b, c,
    result = '', i = 0,
    rest = string.length % 3 // To determine the final padding

  for (; i < string.length;) {
    if ((a = string.charCodeAt(i++)) > 255
      || (b = string.charCodeAt(i++)) > 255
      || (c = string.charCodeAt(i++)) > 255) {
      throw new TypeError('Failed to execute \'btoa\' on \'Window\': The string to be encoded contains characters outside of the Latin1 range.')
    }

    bitmap = (a << 16) | (b << 8) | c
    result += b64.charAt(bitmap >> 18 & 63) + b64.charAt(bitmap >> 12 & 63)
      + b64.charAt(bitmap >> 6 & 63) + b64.charAt(bitmap & 63)
  }

  // If there's need of padding, replace the last 'A's with equal signs
  return rest ? result.slice(0, rest - 3) + '==='.substring(rest) : result
}

/**
 * @author chuwei
 * @date 2020/11/26 15:03
 * @description:base64解码
 **/
function atob(string) {
  const b64re = /^(?:[A-Za-z\d+\/]{4})*?(?:[A-Za-z\d+\/]{2}(?:==)?|[A-Za-z\d+\/]{3}=?)?$/
  const b64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
  string = String(string).replace(/[\t\n\f\r ]+/g, '')
  if (!b64re.test(string)) {
    throw new TypeError('Failed to execute \'atob\' on \'Window\': The string to be decoded is not correctly encoded.')
  }

  // Adding the padding if missing, for semplicity
  string += '=='.slice(2 - (string.length & 3))
  var bitmap, result = '', r1, r2, i = 0
  for (; i < string.length;) {
    bitmap = b64.indexOf(string.charAt(i++)) << 18 | b64.indexOf(string.charAt(i++)) << 12
      | (r1 = b64.indexOf(string.charAt(i++))) << 6 | (r2 = b64.indexOf(string.charAt(i++)))

    result += r1 === 64 ? String.fromCharCode(bitmap >> 16 & 255)
      : r2 === 64 ? String.fromCharCode(bitmap >> 16 & 255, bitmap >> 8 & 255)
        : String.fromCharCode(bitmap >> 16 & 255, bitmap >> 8 & 255, bitmap & 255)
  }
  return result
}
/**
* @author chuwei
* @date 2020/12/19 3:27 下午
* @description:判断ios设备
**/
function isAndroid() {
  let u = navigator.userAgent
  return u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
}

/**
* @author chuwei
* @date 2020/12/19 3:32 下午
* @description:判断ios设备
**/
function isIos() {
  let u = navigator.userAgent
  return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
}

/**
* @author chuwei
* @date 2020/12/20 12:17 下午
* @description:处理登录以后该前往的位置
**/
function goBackWhere(that) {
  let {url,back}=that.$route.query
  if (back){
    that.$router.back()
    return
  }
  if (url){
    url=atob(decodeURI(url))
    that.$router.replace(url)
  }else {
    that.$router.replace('/usercenter')
  }
}

/**
* @author chuwei
* @date 2020/12/23 9:11 下午
* @description:将重要信息变成*号
**/

function hideStr(str,star=0,end=0) {
  let arr=str.split('')
  for (let i = 0; i <arr.length ; i++) {
    if (i>=star&&i<=end){
      arr[i]='*'
    }
  }
  return arr.join('')
}

/**
* @author chuwei
* @date 2020/12/24 15:54
* @description:校验邮箱
**/
function checkEmail(email) {
  return /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/.test(email)
}

/**
* @author chuwei
* @date 2021/3/22 下午7:27
* @description:json转url
**/
function jsonToUrl(obj) {
  return Object.keys(obj).map((key)=>(
    [key]+'='+obj[key]
  )).join('&')
}

function baiduTongJI(){
	var _hmt = _hmt || [];
	(function() {
		document.getElementById('baidu_tj') && document.getElementById('baidu_tj').parentNode.removeChild(document.getElementById('baidu_tj'))
		var hm = document.createElement("script");
		hm.src = "https://hm.baidu.com/hm.js?84edd211dce7a16354d990770d6d9386";
		hm.id='baidu_tj'
		var s = document.getElementsByTagName("script")[0];
		s.parentNode.insertBefore(hm, s);
	})();
}


export {
  PwdMd5,
  checkPhone,
  checkIdCard,
  checkType,
  copy,
  isWeixin,
  isWxClient,
  setSessionStorage,
  getSessionStorage,
  removeSessionStorage,
  setLocalStorage,
  getLocalStorage,
  removeLocalStorage,
  formatQuery,
  getQuery,
  random,
  parseJsonOrNot,
  atob,
  btoa,
  isIos,
  isAndroid,
  goBackWhere,
  hideStr,
  checkEmail,
  jsonToUrl,
	baiduTongJI
}
